// @flow

import ImportSizesContainer from './importSizesContainer'

export default ImportSizesContainer
